function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1D998C",
  fillRule: "nonzero",
  d: "M40.385 0H11.308a1.622 1.622 0 00-1.147.464L.468 10.072c-.302.302-.47.71-.468 1.137v38.43c0 .424.17.832.473 1.133.302.3.714.468 1.142.468h38.77c.428 0 .84-.168 1.143-.468.302-.3.472-.709.472-1.133V1.6c0-.424-.17-.832-.472-1.133A1.624 1.624 0 0040.385 0zM9.692 5.46v4.147H5.508L9.692 5.46zM38.77 48.037H3.231V12.81h8.077c.428 0 .84-.168 1.143-.468.303-.3.472-.709.472-1.133V3.203H38.77v44.834z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D998C",
  fillRule: "nonzero",
  stroke: "#1D998C",
  strokeWidth: 0.84,
  d: "M16.573 26.135l-1.453 1.394 5.153 4.944a1.062 1.062 0 001.454 0l5.153-4.944-1.453-1.394-3.401 3.262V15.96h-2.062v13.437l-3.39-3.262z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1D998C",
  strokeWidth: 3.36,
  d: "M9.24 33.6v6.318h23.48V33.6"
}));

var SvgDefaultIcon = function SvgDefaultIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 52,
    viewBox: "0 0 42 52"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/default-icon.7f5df8c2.svg";
export { SvgDefaultIcon as ReactComponent };